import {METAL_CARD, PVC_CARD, ONE_EDITION_CARD} from './cardMaterial.entity'
import {ONE_EDITION_PATTERN} from './cardPattern.entity'

class CardType{
    name;
    
    materials=[];
    materialSelection=false;
    
            
    colorSelection=false;
    patternSelection=false;
    defaultPattern=null;    
    customText=false;
    
    hasLogo=true;
    customLogo=false;

    kind="ca"
            
    constructor(data={}){
        this.name = data.name        
        this.customText = data.customText ?? this.customText
        this.materials = data.materials ?? this.materials
        this.materialSelection = data.materialSelection ?? this.materialSelection    
        this.colorSelection = data.colorSelection ?? this.colorSelection
        this.hasLogo = data.hasLogo ?? this.hasLogo
        this.customLogo = data.customLogo ?? this.customLogo
        this.patternSelection = data.patternSelection ?? this.patternSelection
        this.defaultPattern = data.defaultPattern ?? this.defaultPattern
    }
}




export const BASIC_CARD = new CardType({
    name: "basic",
    materialSelection:true,
    colorSelection:true,
    hasLogo: true,
    customLogo: false,
    customText:true,
    materials: [PVC_CARD, METAL_CARD]
})

export const PRO_CARD = new CardType({
    name: "pro",
    materialSelection:true,
    colorSelection:true,
    patternSelection:true,
    customText: true,
    customLogo:true,
    materials: [PVC_CARD, METAL_CARD]
})

export const ONE_CARD = new CardType({
    name: "one edition",
    materialSelection:false,
    colorSelection:false,
    hasLogo: false,
    patternSelection:false,
    materials: [ONE_EDITION_CARD],
    defaultPattern: ONE_EDITION_PATTERN
})



export const cardTypes = new Map()

cardTypes.set(BASIC_CARD.name, BASIC_CARD)
cardTypes.set(PRO_CARD.name, PRO_CARD)
cardTypes.set(ONE_CARD.name, ONE_CARD)


